import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
//Import components
import Header from './common/Header'
import Sidebar from './common/Sidebar'
import Footer from './common/Footer'
import Home from './Home'

import Users from './user/Users'
import NewUser from './user/NewUser'
import EditUser from './user/EditUser'

import HoujinUsers from './houjin/user/Users'
import HoujinNewUser from './houjin/user/NewUser'
import HoujinEditUser from './houjin/user/EditUser'

import Menus from './menu/Menus'
import NewMenu from './menu/NewMenu'
import EditMenu from './menu/EditMenu'

import Staffs from './staff/Staffs'
import EditStaff from './staff/EditStaff'

import Clients from './client/Clients'
import EditClient from './client/EditClient'

import Imports from './account/Imports'
import Accounts from './account/Accounts'
import EditAccount from './account/EditAccount'
import TemporaryRegists from './account/TemporaryRegists'

import Invoices from './client/Invoices';
import DetailInvoice from './client/DetailInvoice';

import Roles from './role/Roles'
import NewRole from './role/NewRole'
import EditRole from './role/EditRole'

import Permissions from './permission/Permissions'
import NewPermission from './permission/NewPermission'
import EditPermission from './permission/EditPermission'

import Approval from './approval/Approvals'
import Profile from './Profile'

import Jobs from './job/Jobs'
import EditJob from './job/EditJob'

import History from './history/PaymentTransactionHistory'
import HistoryTicket from './history/PaymentTransactionHistoryTicket'

import JobApplys from './jobapply/JobApplys'
import EditJobApply from './jobapply/EditJobApply'

import Tickets from './ticket/Tickets'
import EditTicket from './ticket/EditTicket'

import TicketRequests from './ticketrequest/TicketRequests'
import EditTicketRequest from './ticketrequest/EditTicketRequest'

import Cashes from './cash/Cashes'
import EditCash from './cash/EditCash'

import Transfers from './transfer/Transfers'
import EditTransfer from './transfer/EditTransfer'

import Message from './messages/Message'

import Chat from './chats/Chat'
import DetailChat from './chats/DetailChat'

import Points from './points/Points'
import CreatePoint from './points/CreatePoint'
import EditPoint from './points/EditPoint'

import Mails from './mails/Mails'
import CreateMail from './mails/CreateMail'
import EditMail from './mails/EditMail'
import DetailMail from './mails/DetailMail'

import NgWords from './ngwords/NgWords'
import CreateNgWord from './ngwords/CreateNgWord'
import EditNgWord from './ngwords/EditNgWord'

import _404 from './static/_404'
import _500 from './static/_500'
import _503 from './static/_503'

const DefaultLayout = ({component: Component, ...rest}) => {
    return (
        <Route {...rest} render={matchProps => (
            <React.Fragment>
                <div className="wrapper">
                    <Sidebar />
                    <div id="content">
                        <Header />
                        <Component {...matchProps} />
                    </div>
                    <Footer />
                </div>
            </React.Fragment>
        )} />
    )
}

const StaticLayout = ({component: Component, ...rest}) => {
    return (
        <Route {...rest} render={matchProps => (
            <Component {...matchProps} />
        )} />
    )
}

const Main = () => (
    <BrowserRouter>
        <Switch>
            <DefaultLayout exact path='/home' component={Home} />

            <DefaultLayout exact path='/staffs' component={Staffs} />
            {/* <DefaultLayout exact path='/staffs/edit/:id' component={EditStaff} /> */}

            <DefaultLayout exact path='/clients' component={Clients} />
            {/* <DefaultLayout exact path='/clients/edit/:id' component={EditClient} /> */}
            <DefaultLayout exact path='/clients/invoices' component={Invoices} />
            <DefaultLayout exact path='/clients/invoices/:startDate/:endDate' component={Invoices} />
            <DefaultLayout exact path='/clients/detail-invoice/:id/:startDate/:endDate' component={DetailInvoice} />

            <DefaultLayout exact path='/accounts' component={Accounts} />
            <DefaultLayout exact path='/accounts/imports' component={Imports} />
            <DefaultLayout exact path='/accounts/edit/:id' component={EditAccount} />
            <DefaultLayout exact path='/temporary-regists' component={TemporaryRegists} />

            <DefaultLayout exact path='/jobs' component={Jobs} />
            <DefaultLayout exact path='/jobs/edit/:id' component={EditJob} />

            <DefaultLayout exact path='/history/:id' component={History} />
            <DefaultLayout exact path='/historyticket/:id' component={HistoryTicket} />

            <DefaultLayout exact path='/jobapplys' component={JobApplys} />
            <DefaultLayout exact path='/jobapplys/edit/:id' component={EditJobApply} />

            <DefaultLayout exact path='/tickets' component={Tickets} />
            <DefaultLayout exact path='/tickets/edit/:id' component={EditTicket} />

            <DefaultLayout exact path='/ticketrequests' component={TicketRequests} />
            <DefaultLayout exact path='/ticketrequests/edit/:id' component={EditTicketRequest} />

            <DefaultLayout exact path='/users' component={Users} />
            <DefaultLayout exact path='/users/create' component={NewUser} />
            <DefaultLayout exact path='/users/edit/:id' component={EditUser} />

            <DefaultLayout exact path='/houjin_users' component={HoujinUsers} />
            <DefaultLayout exact path='/houjin_users/create' component={HoujinNewUser} />
            <DefaultLayout exact path='/houjin_users/edit/:id' component={HoujinEditUser} />

            <DefaultLayout exact path='/menus' component={Menus} />
            <DefaultLayout exact path='/menus/create' component={NewMenu} />
            <DefaultLayout exact path='/menus/edit/:id' component={EditMenu} />

            <DefaultLayout exact path='/roles' component={Roles} />
            <DefaultLayout exact path='/roles/create' component={NewRole} />
            <DefaultLayout exact path='/roles/edit/:id' component={EditRole} />

            <DefaultLayout exact path='/permissions' component={Permissions} />
            <DefaultLayout exact path='/permissions/create' component={NewPermission} />
            <DefaultLayout exact path='/permissions/edit/:id' component={EditPermission} />

            <DefaultLayout exact path='/approvals' component={Approval} />
            <DefaultLayout exact path='/profile' component={Profile} />

            <DefaultLayout exact path='/cashes' component={Cashes} />
            <DefaultLayout exact path='/cashes/edit/:id' component={EditCash} />

            <DefaultLayout exact path='/transfers' component={Transfers} />
            <DefaultLayout exact path='/transfers/edit/:id' component={EditTransfer} />

            <DefaultLayout exact path='/messages' component={Message} />

            <DefaultLayout exact path='/chats' component={Chat} />
            <DefaultLayout exact path='/chats/view/:id' component={DetailChat} />

            <DefaultLayout exact path='/points' component={Points} />
            <DefaultLayout exact path='/points/create' component={CreatePoint} />
            <DefaultLayout exact path='/points/edit/:id' component={EditPoint} />

            <DefaultLayout exact path='/mails' component={Mails} />
            <DefaultLayout exact path='/mails/create' component={CreateMail} />
            <DefaultLayout exact path='/mails/edit/:id' component={EditMail} />
            <DefaultLayout exact path='/mails/view/:id' component={DetailMail} />

            <DefaultLayout exact path='/ngwords' component={NgWords} />
            <DefaultLayout exact path='/ngwords/create' component={CreateNgWord} />
            <DefaultLayout exact path='/ngwords/edit/:id' component={EditNgWord} />

            <StaticLayout exact path='/_404' component={_404} />
            <StaticLayout exact path='/_500' component={_500} />
            <StaticLayout exact path='/_503' component={_503} />

            <StaticLayout component={_404} />
        </Switch>
    </BrowserRouter>
);

export default Main;
